import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { useUser } from '@client/hooks/business/user/useUser';
import { INCIDENT_STATUSES_KEYS } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { hasIncidentUpdateAccess } from '../permissions';
import { incidentFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/compliance/incidents/details/$id/library')({
    component: IncidentLibraryTab,
});

function IncidentLibraryTab() {
    const user = useUser();
    const incident = incidentFormStore.use.formData();

    return (
        <PageController route={Route}>
            <DocumentLibrary
                entity="incident"
                readOnly={!hasIncidentUpdateAccess(user, incident)}
                entityId={incident.id}
                disableUploading={incident.status === INCIDENT_STATUSES_KEYS.closed}
                shouldIncludeRelatedEntities
            />
        </PageController>
    );
}
